module.exports = __webpack_public_path__ + "img/pp-57.569c5cf6.jpg";